import React, { Component } from "react";
import { Form, Header, Icon, Segment, Checkbox } from "semantic-ui-react";
import { withTranslation } from "react-i18next";

import UserInput from "../UserInput";

class LEFConfiguration extends Component {
  handleInputChange = e => {
    let { location, onLocationChange } = this.props;

    if (Object.keys(location).length === 0) return;

    onLocationChange({ ...location, [e.target.name]: e.target.value });
  };

  handleCheckboxChange = (e, { name, checked }) => {
    let { location, onLocationChange } = this.props;

    onLocationChange({ ...location, [name]: checked, ...(!checked ? { lef_account_number: "" } : {}) });
  };
  render() {
    const { location, t } = this.props;

    return (
      <Segment>
        <Header as="h5">
          <Icon name="wrench" />
          <Header.Content>{t("lef_configuration").message || "LEF Configuration"}</Header.Content>
        </Header>
        <Form>
          <Form.Field>
            <Checkbox
              checked={location.is_lef_enabled}
              name="is_lef_enabled"
              label={t("send_leads_to_lef").message || "Send leads to LEF"}
              onChange={this.handleCheckboxChange}
            />
          </Form.Field>

          <Form.Field className="full-width-input">
            <label>{t("account_number").message || "Account number"}</label>
            <UserInput
              value={location.lef_account_number}
              name="lef_account_number"
              disabled={!location.is_lef_enabled}
              placeholder={t("account_number").message || "Account number"}
              onChange={this.handleInputChange}
            />
          </Form.Field>
        </Form>
      </Segment>
    );
  }
}

export default withTranslation()(LEFConfiguration);
